<template>
  <v-layout row wrap style="border-bottom: 1px solid black;">
    <v-flex xs12>
      <h3 class="title px-2 py-4" style="text-decoration: underline;">Medical Contact Preferences</h3>
    </v-flex>
    <v-flex xs12 md6 lg4 pa-2>
      <v-text-field
        name="physician_name"
        label="Physician"
        :rules="drNameRules"
        box
        v-model="physician_name"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md6 lg4 pa-2>
      <v-text-field
        name="physician_phone"
        label="Phone"
        :rules="phoneRules"
        box
        mask="(###) ### - ####"
        v-model="physician_phone"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md6 lg4 pa-2>
      <v-text-field
        name="hospital_preference"
        :rules="hospitalRules"
        label="Hospital Preference"
        box
        v-model="hospital_preference"
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      drNameRules: [v => !!v || "Physician name is required"],
      phoneRules: [v => !!v || "Physician phone is required"],
      hospitalRules: [v => !!v || "Hospital is required"]
    };
  },
  computed: {
    physician_name: {
      get() {
        return this.$store.state.registration.emergencyContacts.physician.name;
      },
      set(value) {
        this.$store.commit(
          "registration/emergencyContacts/setPhysicianName",
          value
        );
      }
    },
    physician_phone: {
      get() {
        return this.$store.state.registration.emergencyContacts.physician.phone;
      },
      set(value) {
        this.$store.commit(
          "registration/emergencyContacts/setPhysicianPhone",
          value
        );
      }
    },
    hospital_preference: {
      get() {
        return this.$store.state.registration.emergencyContacts
          .hospital_preference;
      },
      set(value) {
        this.$store.commit(
          "registration/emergencyContacts/setHospitalPreference",
          value
        );
      }
    }
  }
};
</script>
